
























































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import ITimeTrackingBrand from "@/models/TimeTracking/ITimeTrackingBrand";

const NAMESPACE_TIME_TRACKING_BRAND: string = 'timeTrackingBrands';
const RESOURCE_TIME_TRACKING_BRAND: string = 'tt/brand';

@Component
export default class Brand extends Vue {
  public name: string = "Brand";

  @Action('loadItem', {namespace: NAMESPACE_TIME_TRACKING_BRAND}) loadBrand;
  @Action('loadBrandStats', {namespace: NAMESPACE_TIME_TRACKING_BRAND}) loadBrandDetails;

  @Getter('getItem', {namespace: NAMESPACE_TIME_TRACKING_BRAND}) brand;
  @Getter('getBrandDetails', {namespace: NAMESPACE_TIME_TRACKING_BRAND}) brandDetails;

  @Prop({required: true})
  public item!: ITimeTrackingBrand;

  @Watch('item', {immediate: true, deep: true})
  private onItemChanged() {

    this.loadBrand({
      resource: RESOURCE_TIME_TRACKING_BRAND,
      id: this.item.id
    });

    this.loadBrandDetails({
      resource: RESOURCE_TIME_TRACKING_BRAND,
      id: this.item.id
    });

  }


}
